var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-console */
import { call, delay, put, select } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { loadMenuRequest } from '../../../api/load-menu';
import { getProductsData, getReloadNotificationIsShown, } from '../../selectors';
import { fetchMenuActionSaga, setReloadNotificationIsShownAction, } from '../../actions';
import { getMenuProductsToList } from '../../_utils/get-menu-products-to-list';
import { getChangedMenuConfig } from './_utils/get-changed-menu-config';
export function checkRefreshProductsWorkerSaga(_a) {
    var prevFlattenMenuList, reloadNotificationIsShown, _b, data, error, errorText, headers, newFlattenMenuList, _c, config, areEqual, name_1, routeNameWasInjected, error_1;
    var router = _a.router, loadMenuRequestEndpoint = _a.loadMenuRequestEndpoint, appNamespace = _a.appNamespace, refreshTimeout = _a.refreshTimeout, callbacksWhenNotificationShown = _a.callbacks.callbacksWhenNotificationShown;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!true) return [3 /*break*/, 13];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 9, 10, 12]);
                return [4 /*yield*/, select(getProductsData)];
            case 2:
                prevFlattenMenuList = _d.sent();
                return [4 /*yield*/, select(getReloadNotificationIsShown)];
            case 3:
                reloadNotificationIsShown = _d.sent();
                return [4 /*yield*/, call(loadMenuRequest, {
                        appNamespace: appNamespace,
                        endpoint: loadMenuRequestEndpoint,
                    })];
            case 4:
                _b = _d.sent(), data = _b.data, error = _b.error, errorText = _b.errorText, headers = _b.headers;
                if (error) {
                    throw new Error(JSON.stringify({ errorText: errorText, headers: headers }));
                }
                newFlattenMenuList = getMenuProductsToList({
                    menu: data.menu,
                });
                _c = getChangedMenuConfig({
                    prevFlattenMenuList: prevFlattenMenuList,
                    newFlattenMenuList: newFlattenMenuList,
                }), config = _c.config, areEqual = _c.areEqual, name_1 = _c.name;
                console.log('[]: check equal states', { config: config, areEqual: areEqual, name: name_1 });
                if (areEqual) {
                    return [2 /*return*/];
                }
                if (!(config && config.routeName)) return [3 /*break*/, 8];
                routeNameWasInjected = router.buildState(config.routeName, {});
                console.log('[]: routeNameWasInjected', routeNameWasInjected);
                if (!!routeNameWasInjected) return [3 /*break*/, 6];
                return [4 /*yield*/, put(fetchMenuActionSaga({
                        withoutLoadingIndicator: true,
                        configs: {
                            loadMenuRequestEndpoint: loadMenuRequestEndpoint,
                            appNamespace: appNamespace,
                        },
                    }))];
            case 5:
                _d.sent();
                return [2 /*return*/];
            case 6:
                if (!!reloadNotificationIsShown) return [3 /*break*/, 8];
                return [4 /*yield*/, put(batchActions([
                        setReloadNotificationIsShownAction(),
                        // setModalAction({
                        //   status: 'warning',
                        //   title: reloadNotificationsTitle,
                        //   text: reloadNotificationsText,
                        //   externalContent: notificationsReloadPageContent,
                        //   customHoldTimeout: 60000,
                        // }),
                    ]))];
            case 7:
                _d.sent();
                callbacksWhenNotificationShown();
                _d.label = 8;
            case 8: return [3 /*break*/, 12];
            case 9:
                error_1 = _d.sent();
                console.log('error in refreshProductsWatcherSaga', error_1);
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, delay(refreshTimeout)];
            case 11:
                _d.sent();
                return [7 /*endfinally*/];
            case 12: return [3 /*break*/, 0];
            case 13: return [2 /*return*/];
        }
    });
}
